<template>
    <base-config-drawer ref="drawer" @click:delete-account="$emit('click:delete-account')">

        <v-list-item class="config-item" @click="$emit('click:edit:basic-info')">
            {{ $t('entrance.basic_info') }}
        </v-list-item>

        <v-list-item class="config-item" @click="$emit('click:edit:professional-info')">
            {{ $t('common.edit_professional_info') }}
        </v-list-item>

        <v-list-item class="config-item" @click="$emit('click:select-plan')" v-if="showPlanOptions">
            {{ $t('entrance.change_plan') }}
        </v-list-item>

        <v-list-item class="config-item" @click="toPaymentMethod" v-if="showPlanOptions">
            {{ $t('student.payment_method') }}
        </v-list-item>

        <v-list-item class="config-item" @click="$emit('click:cancel-subscription')"
            v-if="showSubscriptionCancel && showPlanOptions">
            {{ $t('common.unsubscribe') }}
        </v-list-item>

    </base-config-drawer>
</template>

<script>

import BaseConfigDrawer from '@/components/common/ConfigDrawer'

export default {
    components: { BaseConfigDrawer },
    props: {
        showSubscriptionCancel: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        showPlanOptions(vm = this) {
            return vm.paymentsEnabled && vm.account?.accountType === 'company'
        }
    },
    methods: {
        show() {
            this.$refs.drawer.show()
        },
        hide() {
            this.$refs.drawer.hide()
        },
        toPaymentMethod() {
            this.pushRoute({ name: 'company.payment.edit' })
        },
    },
}

</script>
